import {BaseFactory} from "../../../../infrastructure/factories/base-factory";
import {LanguageDomainModel} from "../../models/language/language.domain-model";
import {LanguageViewModel} from "../../models/language/language.view-model";

export class LanguageFactory extends BaseFactory {

  static injectables = [...BaseFactory.injectables];

  createApiObject(model: LanguageDomainModel) {
    const languageModel: LanguageDomainModel = new LanguageDomainModel(model);

    return languageModel;
  }

  createDomainModel(model: LanguageDomainModel): LanguageDomainModel {
    const languageModel: LanguageDomainModel = this.createApiObject(model);

    return languageModel;
  }

  createVM(model: LanguageDomainModel): LanguageDomainModel {
    const languageModel: LanguageDomainModel = new LanguageViewModel(model);

    return languageModel;
  }
}

